"use client";

;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { LoadingSpinner } from "@/components/ui/LoadingSpinner";

export default function Loading() {
	return (
		<LoadingSpinner
			className="h-[calc(100dvh-var(--header-height)-calc(var(--spacing)*30))]"
			loadingLabel="Loading"
		/>
	);
}
